export default "__VITE_ASSET__DCfbBNC6__"